import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { flexGap, scrollBarStyles } from '@doltech/utils/lib/css-style';
import { QuestionNumber } from '../QuestionNumber/QuestionNumber';

const QuestionList = styled.div`
  padding: 2px;
  display: flex;
  flex-wrap: wrap;
  ${flexGap([12, 12])}

  max-height: 60vh;
  overflow-y: auto;
  ${scrollBarStyles({
    size: 6,
    thumbSize: 2,
  })}
`;

const Container = styled.div`
  &.bottom-sheet {
    ${QuestionList} {
      ${flexGap([8, 8])}
    }
  }
`;

interface SectionDictationQuestionListGroupProps {
  type?: 'default' | 'pop-up' | 'bottom-sheet';
  questions?: {
    key?: number;
    questionNumber?: number;
    state?: 'default' | 'correct' | 'in-progress';
    disabled?: boolean;
    selected?: boolean;
  }[];
  onSelect?: (selectedKey: string | number) => void;
}

export const SectionDictationQuestionListGroup = (
  props: SectionDictationQuestionListGroupProps
) => {
  const { type = 'default', questions, onSelect } = props;

  return (
    <Container className={cl('section-dictation-question-list-group', type)}>
      <QuestionList>
        {questions?.map(({ key, questionNumber, state, disabled, selected }) => {
          return (
            <QuestionNumber
              key={key}
              type={state || 'default'}
              size={type === 'default' ? '36px' : '40px'}
              text={questionNumber.toString()}
              onClick={() => {
                onSelect?.(key);
              }}
              selected={selected}
              disabled={disabled}
            />
          );
        })}
      </QuestionList>
    </Container>
  );
};
